<template>
  <div class="wl-container">
    <div class="updateGuide" v-if="false"></div>
    <div class="wl-content-container">
      <!-- 搜索框 -->
      <div class="wl-search-bar">
        <div class="wl-left">
          <el-input :placeholder="$t('USER_WORKING_EMAIL')+','+$t('COMMON_USER_NAME')"
                    v-model="searchContent"
                    clearable
                    @keyup.enter.native="searchUser"
                    maxlength="100"
                    class="input-with-select">
            <i slot="suffix" class="el-input__icon el-icon-search" @click="searchUser" style="cursor: pointer"/>
          </el-input>
        </div>
        <div class="wl-right">
          <!-- 添加新用户 -->
          <el-button
            @click="addClientUser"
            class="wl-green"
            icon="el-icon-plus">{{$t('ADD_CLIENT_USER')}}
          </el-button>
          <!-- 给客户发送初始密码 -->
          <el-popover
            :width="$i18n.locale === 'zh' ? 267 : 403"
            trigger="manual"
            v-model="ifUnsendPwdUserExist"
            placement="top-start"
            popper-class="clientUser-popver-content"
            style="margin: 0 10px;"
          >
            <el-button slot="reference"
                       @click="sendEmailOpen"
                       icon="el-icon-message"
                       class="wl-green">
              {{$t('PAGE_CLIENTUSER_PAD_EMAIL')}}
            </el-button>
            <div class="">
              <div style="margin-bottom: 5px;">
                <i class="el-icon-warning" style="color:#fd349c;"></i>
                {{$t('please_sent_initial_password')}}
              </div>
              <div style="display: flex; flex-direction: row; justify-content: flex-end;">
                <el-button @click="ifUnsendPwdUserExist = !ifUnsendPwdUserExist"
                           size="mini">
                  {{$t('i_know')}}
                </el-button>
              </div>
              <div class="popver-arrow"></div>
            </div>
          </el-popover>
          <!-- 设置邮箱白名单 -->
          <el-button icon="el-icon-document"
                     class="wl-green"
                     @click="showWhiteList"
          >
            {{ $t('SET_WHITE_LIST') }}
          </el-button>
          <!-- 设置ip白名单 -->
          <el-button icon="el-icon-document"
                     class="wl-green"
                     @click="showIpWhiteList"
          >
            {{ $t('SET_IP_WHITE_LIST') }}
          </el-button>
          <el-button @click="assignSameRole"
                     :disabled="multiSelect.show"
                     class="wl-green svg-btn" style="margin-left: 10px;"><img src="@/assets/img/icon-batchsetting.svg"
                                                                              width="100%" class="btn-icon"/>{{$t('patch_set_role')}}
          </el-button>
          <el-button @click="patchDelete"
                     :disabled="multiSelect.show"
                     class="wl-green svg-btn"><img src="@/assets/img/icon-batchdeletion.svg" width="100%"
                                                   class="btn-icon"/>{{$t('patch_delete_user')}}
          </el-button>
          <!-- 下载导入模板 -->
          <el-button
            @click="download"
            class="wl-green"
            icon="el-icon-download">
            {{$t('COMMON_DOWNLOAD_TEMP')}}
          </el-button>
          <!-- 导入 -->
          <el-upload class="template-uploader"
                     action="url"
                     :http-request="uploadFiles"
                     :show-file-list="false"
                     :on-success="handleAvatarSuccess"
                     :before-upload="beforeAvatarUpload">
            <el-button class="wl-green svg-btn">
              <img src="@/assets/img/icon-import.svg" width="100%" class="btn-icon"/>
              {{$t('batchImport')}}
            </el-button>
          </el-upload>
          <!-- 导出 -->
          <el-button
            @click="downloadClientUser"
            class="wl-green"
            style="margin-left: 10px;"
            icon="el-icon-download">
            {{$t('cilentExportUserList')}}
          </el-button>
        </div>
      </div>
      <div style="font-size: 12PX; color: #fd349c">
        <i class="el-icon-warning"></i>
        {{$t('CLIENT_USERS_TIPS')}}
      </div>
      <!-- 表格 -->
      <div :class="['table-container-wrapper', multiSelect.show? 'show-table-bottom-operate': '',{'guide-table':updateGuide}]">
        <div
            v-if="false"
            class="updateGuideTitle"
            :style="{ height: `${updateGuideTitleHeight}px`, right: '100px' }"
        >
            <div class="updateGuideTip" :style="{ top: `${updateGuideTitleHeight + 10}px` }">
                <div class="margin-bottom-10" v-html="$t('CLIENT_NOTICE')"></div>
                <el-button @click="gotItClick" class="guide-btn">{{ $t('gotIt') }}</el-button>
            </div>
        </div>
        <el-table height="100%"
                  v-loading="loading"
                  :data="data"
                  :row-class-name="userSourceRowClass"
                  :cell-class-name="noRoleCell"
                  border
                  stripe
                  @selection-change="e => {multiSelect.choosed = e}"
                  ref="table"
                  :header-cell-class-name="updateGuideClass"
        >
          <el-table-column
            v-if="multiSelect.show"
            type="selection"
            width="55"></el-table-column>
          <el-table-column align="center"
                           type="index"
                           width="50">
          </el-table-column>
          <el-table-column prop="userAccount"
                           width="150"
                           :label="$t('USER_WORKING_EMAIL')">
          </el-table-column>
          <el-table-column prop="phone"
                           width="120"
                           :label="$t('USER_WORKING_PHONE')">
          </el-table-column>
          <el-table-column prop="title"
                           :label="$t('TABLE_HEADER_title2')">
          </el-table-column>
          <el-table-column prop="userName"
                           :label="$t('COMMON_USER_NAME')">
          </el-table-column>
          
          <el-table-column prop="createDate"
                           width="110"
                           :label="$t('create_date')">
            <template slot-scope="scope">
              {{scope.row.createDateString | formatDate}}
            </template>
          </el-table-column>
          <el-table-column prop="identityType"
                           min-width="230"
                           :label="$t('TABLE_HEADER_CLIENT_IDENTITY')">
            <template slot-scope="scope">
              <el-select style="width: 100%"
                         v-model="scope.row.identityType"
                         :placeholder="$t('TABLE_HEADER_CLIENT_IDENTITY')"
                         @change="changeIdentityType(scope.row)">
                <el-option v-for="item in identityTypeOpt"
                           :key="item.code"
                           :label="item.value"
                           :value="item.code">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="ifContact"
                           align="center"
                           width="150"
                           :label="$t('TABLE_HEADER_ifContact_flag')">
            <template slot-scope="scope">
              <el-switch @change="changeIfContact(scope.row)"
                         v-model="scope.row.ifContact"
                         class="switch-width-cls"
                         active-color="#3879eb"
                         inactive-color="#a9acaf">
              </el-switch>
            </template>
          </el-table-column>
        
          <el-table-column prop="status"
                           width="170"
                           :label="$t('Activated')"
                           align="center">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.deactivateDescription" v-if="scope.row.deactivateDescription">
                <el-switch @change="changeStatus(scope.row)"
                           v-model="scope.row.status"
                           class="switch-width-cls"
                           active-value="1"
                           inactive-value="0">
                </el-switch>
              </el-tooltip>
              <el-switch
                v-else
                @change="changeStatus(scope.row)"
                v-model="scope.row.status"
                class="switch-width-cls"
                active-value="1"
                inactive-value="0"
              />
            </template>
          </el-table-column>
          <el-table-column prop="deactivateSetting"
                           width="140"
                           :label="$t('Deactivate_Setting')">
            <template #header>
              <div class="th" >
                <!-- 表头标题 -->
                <div class="th-label">{{ $t('Deactivate_Setting') }}</div>
                <!-- 编辑icon -->
                <el-dropdown @command="onDeactivateBatchEdit">
                  <div class="th-edit">
                    <i class="el-icon-edit-outline"></i>
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <template v-for="(v, k) in deactivateSettingOptions">
                      <el-dropdown-item
                        :key="k"
                        :command="v.code"
                      >{{ $t(`deactivate_setting._${v.code}`) }}
                      </el-dropdown-item>
                    </template>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
            <template slot-scope="scope">
              <el-select style="width: 100%"
                         v-model="scope.row.deactivateSetting"
                         :disabled="scope.row.status === '0'"
                         :placeholder="$t('Deactivate_Setting')"
                         @change="onDeactivateEdit(scope.row)">
                <el-option v-for="item in deactivateSettingOptions"
                           :key="item.code"
                           :label="$t(`deactivate_setting._${item.code}`)"
                           :value="item.code">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="lastActiveTime"
                           width="100"
                           :label="$t('Last_Active_Time')">
          </el-table-column>
          <el-table-column width="100"
                           :label="$t('Date_Type')">
              <template slot-scope="scope">
                <span style="word-break: break-word;">{{ $t(`activeTimeType_${scope.row.activeTimeType}`) }}</span>
              </template>
          </el-table-column>

           <el-table-column width="180" fixed="right">
             <template slot="header">
                  <span style="color:#fd349c; margin-right: 5px; vertical-align: center">*</span>{{ $t('CLIENT_TABLE_HEADER_Access_Level') }}
                    <el-tooltip class="item" effect="dark" placement="top" >
                          <div slot="content" v-html="$t('CLIENT_TABLE_HEADER_Access_Level_Tip')"
                          ></div>
                        <i class="el-icon-warning" style="color:#fd349c; margin-right: 5px"></i>
                    </el-tooltip>
              </template>
              <template slot-scope="scope">
                  <AccessLevelSelect :initData="scope.row.accessType" tailoredShow @change="(val)=>handleAccessLevelChange(scope.row,val)"/>
              </template>
          </el-table-column>

          <el-table-column width="190" fixed="right" :label="$t('CLIENT_TABLE_HEADER_CLIENT_ENTITIES')">
                <template slot="header">
                   <span style="color:#fd349c; margin-right: 5px; vertical-align: center">*</span>{{ $t('CLIENT_TABLE_HEADER_CLIENT_ENTITIES') }}
                </template>
              <template slot-scope="scope">
                  <el-select :key="scope.$index+'null'" v-if="!scope.row.accessType" style="width:100%" value=""></el-select>
                  <el-select :key="scope.$index+'All'" v-else-if="scope.row.accessType==='ALL'" style="width:100%" disabled :value="$t('All_ENTITIES')"></el-select>
                  
                  <select-tree  v-else-if="scope.row.accessType==='SPECIFIC'&&scope.row.refresh" size="mini" :data="orgData" style="width:100%" 
                    :filterable="true" :check-strictly="true" :defaultCheckedKeys="scope.row.clientEntityIds" 
                      @visible-change="(list)=>handleVisibleChange(scope.row,list)"
                      :key="scope.row.id"
                      :defaultExpandAll="true" :defaultProps="defaultProps" :placeholder="$t('SELECT_TYPE')">
                  </select-tree>
                  
                  <el-select class="mb_20" v-else collapse-tags multiple v-model="scope.row.roleList" :placeholder="$t('SELECT_ROLE_TYPE')"
                        @visible-change="(val)=>handleRoleChange(scope.row,val)" style="width:100%">
                      <el-option v-for="item in roleList"
                                        :key="item.roleId"
                                        :label="item.roleName"
                                        :value="item.roleId"
                                        :disabled="loading"
                              >
                      </el-option>
                  </el-select>
                </template>
          </el-table-column>

          <el-table-column prop="action"
                           fixed="right"
                           width="100"
                           align="center"
                           :label="$t('TABLE_HEADER_Action')">
            <template slot-scope="scope">
              <i class="el-icon-edit-outline wl-icon-edit"
                 @click="onEditClientUser(scope.row)"></i>
              <i style="margin-left: 10px"
                 class="el-icon-delete wl-icon-delete"
                 @click="onDeleteClientUser(scope.row)"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="wl-btn-container" v-show="multiSelect.show">
        <el-button class="cancel-btn" @click="cancelPatchMethod">{{$t('comment_reSet')}}</el-button>
        <!-- 右下角按钮的文案根据多选模式来显示不同的内容 -->
        <el-button @click="commitPatchMethod"
                   :disabled="multiSelect.choosed.length === 0"
                   class="wl-green">{{{
          'assign_role': $t('patch_set_role'),
          'patch_delete': $t('patch_delete_user')
          }[multiSelect.mode]}}
        </el-button>
      </div>
      <el-pagination class="wl-pagination"
                     :current-page="pagination.pageNum"
                     :page-size="pagination.pageSize"
                     @size-change="onSizeChange"
                     @current-change="onCurrentPageChange"
                     :page-sizes="[10, 50, 100]"
                     layout="prev, pager, next, sizes, total"
                     :total="pagination.total">
      </el-pagination>
    </div>

     <patchRoleDialog :visible="patchRoleVisible" :roleList='roleList' :allNodes="allNodes" :data="orgData" 
        @submit="batchSetRole" @close='patchRoleVisible=false'/>
    <!-- 新增的弹框 -->
    <clientUser-add v-if="addVisible"
                    :saveLoading="btnLoading"
                    :roleList="roleList"
                    :identityTypeOpt="identityTypeOpt"
                    :initData='initData'
                    :emailList="emailList"
                    :onCancel="toggleAddVisible"
                    :onAdd="saveClientUser"/>
    <clientUser-email v-if="addVisibleEmail"
                      :roleList="roleList"
                      :saveLoading="emailBtnLoading"
                      :onCancel="toogleEmailVisible"
                      :onAdd="sendEmail"/>
    <whiteList
      v-if="whiteListVisible"
      :whiteListVisible="whiteListVisible"
    >
    </whiteList>
    <ip-white-list v-if="ipWhiteListVisible" :ipWhiteListVisible="ipWhiteListVisible"/>

  </div>
</template>
<script>
  import API from '@/api'
  import {loading, isIE, dateFormat, UserInput} from '@/utils'
  import clientUserAdd from './clientUser-add'
  import clientUserEmail from './clientUser-email'
  import {mapGetters} from 'vuex'
  import whiteList from "./whiteList";
  import ipWhiteList from "./ipWhiteList";
  import AccessLevelSelect from "./accessLevelSelect.vue"
  import selectTree from "./selectTree.vue"
  import patchRoleDialog from "./patchRoleDialog.vue"

  export default {
    name: 'user',
     components: {
      clientUserAdd,
      clientUserEmail,
      whiteList,
      ipWhiteList,
      AccessLevelSelect,
      selectTree,
      patchRoleDialog
    },
    data() {
      return {
        updateGuideTitleHeight:0,
        updateGuide:false,
        patchRoleVisible:false,
        defaultProps: {
            children: 'childEntity',
            label: 'entityName'
        },
        orgData:[],
        addVisibleEmail: false,
        addVisible: false,
        siteId: '',
        data: [],
        pagination: {
          pageNum: 1,
          pageSize: 10,
          total: 0
        },
        loading: false,
        searchContent: '',
        btnLoading: false,
        emailBtnLoading: false,
        initData: '',
        roleList: [],
        identityTypeOpt: [],
        fileParams: new FormData(),
        whiteListVisible: false,
        ipWhiteListVisible: false,
        emailList: [],
        multiSelect: {      // 多选操作
          show: false,    // 显示多选框
          choosed: [],    // 选择了
          mode: ''        // 多选操作模式
        },
        patchAssignRole: {
          show: false,
          selected: [],
          loading: false
        },
        ifUnsendPwdUserExist: false,
        deactivateSettingOptions: [],
        allNodes:[],
      }
    },
    filters: {
      formatDate: value => {
        return dateFormat(new Date(value), 'yyyy-MM-dd')
      }
    },
    computed: {
      ...mapGetters('common', {
        getSite: 'getSite'
      })
    },
    mounted() {
      this.siteId = this.getSite.siteId
      this.getClientUserList()
      this.getRoulesList()
      this.getClientIdentityOpt()
      this.checkIfUnsendPwdUserExist()
      this.getClientPermission()
      this.getBehavior();

      
      window.addEventListener("resize", () => {
        this.setPopoverPosition()
      });
      window.reloadPageByI18n = () => {
        this.setPopoverPosition()
      }

      this.setPopoverPosition()
      this.getDeactivateSettingOptions()
    },
    beforeDestroy() {
      // FIXME: removeEventListener解绑的不是addEventListener绑定的方法
      window.removeEventListener('resize', this.setPopoverPosition)
    },
    methods: {
       handleVisibleChange(row,list) {
            const clientEntityIds = list.map(v=>v.id);
            if(row.clientEntityIds&&row.clientEntityIds.length === clientEntityIds.length&& 
                row.clientEntityIds.every(v=>clientEntityIds.includes(v))) return;
            if(list.length===this.allNodes.length&&row.accessType==='SPECIFIC'){
                this.$confirm(this.$t("ROLE_CHANGE_TIP"), this.$t('COMMON_TIP'), {
                confirmButtonText: this.$t('btn_confirm'),
                cancelButtonText: this.$t('btn_cancel'),
                type: 'warning'
                }).then(()=>{
                    row.accessType = "ALL";
                    this.changeRole({...row,clientEntityIds});
                    return 
                }).catch(action=>{
                    if(action ==='cancel'){
                        this.$set(row,"clientEntityIds",row.clientEntityIds);
                        this.allNodes.forEach(e=>e.checked= false)
                        row.refresh = false;
                        this.$nextTick(()=>this.$set(row,"refresh",true))
                    }
                })
               return
            }
            this.changeRole({...row,clientEntityIds});
        },
       handleAccessLevelChange(row,val){
            row.accessType =val;
            if(val ==="SPECIFIC"){
                row.clientEntityIds=[];
                this.allNodes.forEach(e=>e.checked= false)
            }
            if(val ==="ALL"){
                this.changeRole(row);
            }
        },
      handleRoleChange(data,val){
        if(val || (data.roleList.length == data.roleObjList.length && data.roleObjList.every(v=>data.roleList.includes(v.roleId)))) return;
        if(data.roleList&& !data.roleList.length) return
        const params = {
                siteId: this.getSite.siteId,
                userIds: [`${data.id}`],
                accessType:data.accessType,
                entityIdList:data.clientEntityIds,
                roleIds:data.roleList,
                userType: "2"
            }
        this.updateMemberRole(params)
      },
       changeRole(data) {
            const params = {
                siteId: this.getSite.siteId,
                userIds: [`${data.id}`],
                // roleIds: data.roleIdList
                accessType:data.accessType,
                entityIdList:data.clientEntityIds,
                userType: "3"
            }
            this.updateMemberRole(params);
        },
        batchSetRole(row){
          const {clientEntityIds,accessType,roleIdList}=row;
        
          if(accessType !=='TAILORED'){
              const params= { siteId: this.getSite.siteId,
                  userIds: this.multiSelect.choosed.map(v=>v.id),
                  accessType:accessType,
                  entityIdList:clientEntityIds,
                  userType: "1"}
            this.updateMemberRole(params);
            // this.multiSelect.show =false
          }else{
            const data = {
              siteId: this.getSite.siteId,
              userIds: this.multiSelect.choosed.map(v=>v.id),
              accessType:accessType,
              roleIds:roleIdList,
              userType: "2"
            }
            if(row.accessType ==="TAILORED"&&roleIdList&& !roleIdList.length) return
            this.updateMemberRole(data)
          }
          this.multiSelect.show = false;
      },
      updateMemberRole(params){
         API.kpTMember.updateMemberRole(params).then((res) => {
                  if (res.code == '1') {
                      this.$message.success(this.$t('msg_success'))
                      this.patchRoleVisible = false;
                      this.getClientUserList()
                  } else {
                      this.$message.error(this.$t(res.code))
                  }
              })
      },
     
        getClientPermission  (row) {
          row = row || {roleIdList: []};
          const params = {
              siteId: this.siteId,
              roleId: row.roleIdList[0],
          }
          API.kpUserRole.queryKPMGPermission(params).then(res => {
              if (res.code == '1') {
                  this.orgData =[ Object.assign({}, {row: row}, res.data)]
                  this.getAllPermissions();
              }else {
                  this.$message.error(this.$t(res.code));
              }
          })
      },
       getAllPermissions(){
            const stack = [...this.orgData]
            this.allNodes = [this.orgData]
            while(stack.length) {
                const node = stack.pop()
                if (node.childEntity) {
                    node.childEntity.forEach(item => {
                        stack.push(item)
                        this.allNodes.push(item)
                    })
                }
                
            }
        },
      getClientIdentityOpt() {
        API.common.getDict({dictName: 'client_identity_type'}).then(res => {
          if (res.code === '1') {
            this.identityTypeOpt = res.data.map(item=>({
              code:item.code,
              value:this.$t(`client_identity_type.${item.code}`)
            }))
          } else {
            this.$message.error(this.$t(res.code))
          }

        })
      },
      setPopoverPosition() {
        let popover = document.querySelector('.clientUser-popver-content')
        if (this.$i18n.locale === 'zh') {
          popover.style.top = '-44px'
          popover.style.left = (document.getElementsByClassName('el-popover__reference')[0].offsetLeft - 280) + 'px'

        } else {
          popover.style.top = '-53px'
          popover.style.left = (document.getElementsByClassName('el-popover__reference')[0].offsetLeft - 480) + 'px'
        }
        popover.style.backgroundColor = '#303133'
        popover.style.color = '#ffffff'
        const _i = setInterval(() => {
          if (document.getElementsByClassName('popper__arrow') && document.getElementsByClassName('popper__arrow')[0] && document.getElementsByClassName('popper__arrow')[0].style) {
            clearInterval(_i)
            document.getElementsByClassName('popver-arrow')[0].style.left = document.getElementsByClassName('popper__arrow')[0].style.left
            document.getElementsByClassName('popper__arrow')[0].style.display = "none"
          }
        }, 300)
      },
      // 查询有没有未发送初始密码的客户
      checkIfUnsendPwdUserExist() {
        const params = {
          siteId: this.getSite.siteId,
          pageNum: 1,
          pageSize: 1,
          emailStatus: false
        };
        API.clientUser.notifyUser(params).then(res => {
          if (res.code == '1') {
            if (res.data.total > 0) {
              this.ifUnsendPwdUserExist = true
            }
          } else {
            this.$message.error(this.$t(res.code));
          }
        });
      },
      // 提交批量分配角色
      commitPatchAssignRole() {
        if (this.patchAssignRole.selected.length == 0) {
          this.$message.error(this.$t('please_select_role'))
          return
        }
        this.patchAssignRole.loading = true
        API.clientUser.batchUpdateClientUser({
          siteId: this.getSite.siteId,
          roleIds: this.patchAssignRole.selected,
          userIds: this.multiSelect.choosed.map(v => v.id)
        }).then(res => {
          this.patchAssignRole.loading = false
          if (res.code == '1') {
            this.patchAssignRole = {
              show: false,
              selected: [],
              loading: false
            }
            this.$refs.table.clearSelection()
            this.multiSelect = {
              show: false,
              choosed: [],
              mode: ''
            }
            this.getClientUserList()
            this.$message({
              type: 'success',
              message: this.$t('msg_success')
            });
          } else {
            this.$message.error(this.$t(res.code))
          }
        })
      },
      // 取消批量操作
      cancelPatchMethod() {
        this.$refs.table.clearSelection()
        this.multiSelect = {
          show: false,
          choosed: [],
          mode: ''
        }
      },
      // 提交批量操作
      commitPatchMethod() {
        switch (this.multiSelect.mode) {
          case 'assign_role': {
            this.patchAssignRole = {
              show: true,
              selected: [],
              loading: false
            }
            this.patchRoleVisible = true;
          }
            break
          case 'patch_delete': {
            const forbidDel = this.multiSelect.choosed.find(v => v.status == '1')
            if (forbidDel) {
              this.$message({
                type: 'error',
                message: this.$t('patch_delete_client_user_forbid')
              });
              return
            }

            this.$confirm(this.$t('batchDeleteUserConfirm'), {
              confirmButtonText: this.$t('btn_confirm2'),
              cancelButtonText: this.$t('btn_cancel'),
              type: 'error',
              dangerouslyUseHTMLString: true,
              cancelButtonClass: 'cancel-btn',
              confirmButtonClass: 'wl-green',
              center: false,
            }).then(() => {
              const form = new FormData()
              form.append('userIds', this.multiSelect.choosed.map(v => v.id))
              form.append('siteId', this.siteId)
              API.clientUser.batchDeleteClientUser(form).then(res => {
                if (res.code == '1') {
                  this.pagination.pageNum = 1
                  this.getClientUserList()
                  this.$refs.table.clearSelection()
                  this.multiSelect = {
                    show: false,
                    choosed: [],
                    mode: ''
                  }
                  this.$message({
                    type: 'success',
                    message: this.$t('msg_success')
                  });
                } else {
                  this.$message.error(this.$t(res.code))
                }
              })
            })
          }
            break
        }
      },
      assignSameRole() {
        this.$refs.table.clearSelection()
        this.multiSelect = {
          show: true,
          choosed: [],
          mode: 'assign_role'
        }
      },
      patchDelete() {
        this.$refs.table.clearSelection()
        this.multiSelect = {
          show: true,
          choosed: [],
          mode: 'patch_delete'
        }
      },
      onRoleChange(row, row2) {
        if (row.roleList.length <= 0) {
          this.$confirm(this.$t('last_role_delete'), '', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: this.$t('btn_confirm'),
            cancelButtonText: this.$t('btn_cancel'),
            type: 'warning'
          }).then(() => {
            this.updateRole(row)
          }).catch(() => {
            row.roleList = [...row.roleListBackup]
          });
        } else {
          this.updateRole(row)
        }
      },
      updateRole(row) {
        row.role = row.roleList.map(v => {
          if (typeof v == 'object') return v.roleId ? v.roleId : ""
          else if (typeof v == 'string') return v
          else return ''
        })
        if(row.accessType ==="TAILORED"&& !row.role.length) return
        this.initData = row
        const params = {
          siteId: this.siteId,
          userId: this.initData.id,
          userName: row.userName,
          userAccount: row.userAccount,
          title: row.title,
          isContact: row.ifContact,
          roleIds: row.role,
          backMail: row.backMail
        }
        this.loading = true
        API.clientUser
          .updateClientUser(params)
          .then(res => {
            this.loading = false
            if (res.code == '1') {
              this.$message.success(this.$t('msg_success'))
              this.getClientUserList()
            } else {
              this.$message.error(this.$t(res.code))
            }
          })
          .catch(e => {
            console.error(e);
            this.$message.error(this.$t('SYS_USER_003'))
          })
          .finally(() => {
            this.loading = false
            this.btnLoading = false
          })
      },
      noRoleCell({row,  columnIndex}) {
        if ((columnIndex === 13 && ((row.accessType==='TAILORED'&& !row.roleList.length)
           || (row.accessType==='SPECIFIC'&& !row.clientEntityIds.length)
           || (!row.accessType&&!row.clientEntityIds.length)) )
           || columnIndex === 12&&!row.accessType) {
          return 'red'
        }
      },
      userSourceRowClass({row, rowIndex}) {
        return row.source === 2 ? 'confirmation-user-row' : ''
      },
      showIpWhiteList() {
        this.ipWhiteListVisible = true
      },
      showWhiteList() {
        this.whiteListVisible = true
      },
      closeWhiteList(data) {
        this.whiteListVisible = data
      },
      handleAvatarSuccess(res, file) {

      },
      beforeAvatarUpload(file) {
        const isExcel =
          file.type === 'application/vnd.ms-excel' ||
          file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
          file.type === 'image/png'
        const isLt2M = file.size / 1024 / 1024 < 5

        if (!isExcel) {
          this.$message.error(this.$t('import_file_type_error'))
        }
        if (!isLt2M) {
          this.$message.error(this.$t('import_file_size_error'))
        }
        return isExcel && isLt2M
      },
      uploadFiles(item) {
        this.fileParams = new FormData()
        this.fileParams.append('siteId', this.siteId)
        this.fileParams.append('file', item.file)
        this.upload()
      },
      async upload() {
        let service = loading()
        try {
          service.upload()
          const {data, code, errDetails} = await API.clientUser.importClientUserTemplate(this.fileParams)
          if (code == '1') {
            this.$message.success(this.$t('msg_success'))
            this.getClientUserList()
          } else {
            this.$message.error(this.$t(errDetails.msg))
          }
        } catch (e) {
          console.log(123, 3)
        } finally {
          service.close()
        }
      },
      async download() {
        let service = loading()
        try {
          service.download()
          const res = await API.clientUser.downloadClientUserTemplate()
          if (/application\/json/.test(res.type)) {

            let reader = new FileReader()
            reader.onload = e => {
              if (e.target.readyState === 2) {
                let resJson = {}
                resJson = JSON.parse(e.target.result)
                this.$message.error({duration: 5000, message: this.$t(resJson.code)})
              }
            }
            reader.readAsText(res)
          } else if (/application\/octet-stream/.test(res.type)) {

            let blob = new Blob([res])
            if (isIE()) {
              navigator.msSaveBlob(blob, 'Client Users Import Template.xlsx')
            } else {
              let url = window.URL.createObjectURL(blob)
              let link = document.createElement('a')
              link.style.display = 'none'
              link.href = url
              link.setAttribute('download', 'Client Users Import Template.xlsx')
              document.body.appendChild(link)
              link.click()
            }
          }
        } catch (e) {
        } finally {
          service.close()
        }
      },
      searchUser: _.debounce(
        function () {
          if (this.searchContent && !UserInput.reg1.test(this.searchContent)) {
            this.$message.error(this.$t('ILLEGAL_USER_INPUT_02'))
            return
          }
          this.onCurrentPageChange(1)
        },
        500,
        {leading: true}
      ),
      onSizeChange(value) {
        this.pagination.pageNum = 1
        this.pagination.pageSize = value
        this.getClientUserList()
      },
      onCurrentPageChange(current) {
        this.pagination.pageNum = current
        this.getClientUserList()
      },
      getRoulesList() {
        const params = {
          siteId: this.siteId,
          pageNum: 1,
          pageSize: 99999
        }
        API.clientRoles.queryClientRoleList(params).then(res => {
          if (res.code === '1') {
            this.roleList = res.data.records
          } else {
            this.$message.error(this.$t(res.code))
          }
        })
      },
      gotItClick() {
            let param = {
                clientUserNoticeFlag: 1
            }
            API.common.updateBehavior(param).then((res) => {
                if (res.code === '1') {
                    this.updateGuide = false
                    this.updateGuideStep = 0
                } else {
                    this.$message.error(this.$t(res.code))
                }
            })
        },
       getBehavior() {
            API.common.queryBehavior().then((res) => {
                if (res.code === '1') {
                    this.updateGuide = res.data.clientUserNoticeFlag === 0
                    this.changeGuideTitleHeight()
                } else {
                    this.$message.error(this.$t(res.code))
                }
            })
        },
      getClientUserList() {
        this.loading = true
        let params = {
          siteId: this.siteId,
          pageNum: this.pagination.pageNum,
          pageSize: this.pagination.pageSize,
          queryParam: this.searchContent
        }
        API.clientUser
          .queryClientUserList(params)
          .then(res => {
            if (res.code === '1' && res.data.records) {
              this.loading = false
              this.data = res.data.records.map(v => {
                v.roleObjList = v.roleList ? [... v.roleList]:[];
                v.roleList = v.roleList ? v.roleList.map(vv => vv.roleId) : []
                v.roleListBackup = [...v.roleList];
                v.refresh = true;
                return v
              })
              this.pagination.total = res.data.total
            } else {
              this.$message.error(this.$t(res.code))
            }
          })
          .catch(e => {
            console.error(e);
            this.$message.error(this.$t('SYS_USER_003'))
          })
          .finally(() => {
            this.loading = false
            this.$forceUpdate()
          })
      },
      onDeleteClientUser(data) {
        this.$confirm(this.$t('batchDeleteUserConfirm'), {
          confirmButtonText: this.$t('btn_confirm2'),
          cancelButtonText: this.$t('btn_cancel'),
          type: 'error',
          dangerouslyUseHTMLString: true,
          center: false
        }).then(() => {
          if (data.id) {
            const form = new FormData()
            form.append('userIds', [data.id])
            form.append('siteId', this.siteId)
            API.clientUser.deleteClientUser(form).then(res => {
              if (res.code == '1') {
                this.$message.success(this.$t('msg_success'))
                this.getClientUserList()
              } else {
                if (res.code === 'CLIENT_USER_015') {
                  this.$message({
                    dangerouslyUseHTMLString: true,
                    type: 'error',
                    message: this.$t(res.code)
                  })
                } else {
                  this.$message.error(this.$t(res.code))
                }
              }
            })
          }
        })
      },
      changeStatus(data) {
        const params = {
          clientUserIds: [data.id],
          userStatus: data.status,
          siteId: this.siteId
        }
        API.clientUser.changeClientUserStatus(params).then(res => {
          if (res.code === '1') {
            this.$message.success(this.$t('msg_success'))
            this.getClientUserList()
          } else {
            this.$message.error(this.$t(res.code))
          }
        })
      },
      changeSuperFlag(data) {
        if (data.superFlag) {
          this.$confirm(this.$t('confirmation_superuser_open_tip'), {
            confirmButtonText: this.$t('btn_confirm'),
            cancelButtonText: this.$t('btn_cancel'),
            type: 'warning',
            cancelButtonClass: 'cancel-btn',
            confirmButtonClass: 'wl-green'
          }).then(() => {
            this.changeSuperFlagData(data)
          }).catch(() => {
            data.superFlag = !data.superFlag
          })
        } else {
          this.changeSuperFlagData(data)
        }
      },
      changeSuperFlagData(data) {
        const params = {
          clientUserId: data.id,
          superFlag: data.superFlag,
          siteId: this.siteId
        }
        API.clientUser.changeSuperFlag(params).then(res => {
          if (res.code == '1') {
            this.$message.success(this.$t('msg_success'))
          } else {
            this.$message.error(this.$t(res.code))
          }
        })
      },
      changeIfContact(data) {
        const params = {
          clientUserId: data.id,
          ifContact: data.ifContact,
          siteId: this.siteId
        }
        API.clientUser.changeClientUserContact(params).then(res => {
          if (res.code == '1') {
            this.$message.success(this.$t('msg_success'))
            // this.getClientUserList()
          } else {
            this.$message.error(this.$t(res.code))
          }
        })
      },
      onEditClientUser(data) {
        this.initData = data
        this.addVisible = !this.addVisible
      },
      async downloadClientUser() {
        let service = loading()
        try {
          service.download()
          const res = await API.clientUser.downloadClientUser({siteId: this.siteId})
          if (/application\/json/.test(res.type)) {

            let reader = new FileReader()
            reader.onload = e => {
              if (e.target.readyState === 2) {
                let resJson = {}
                resJson = JSON.parse(e.target.result)
                this.$message.error({duration: 5000, message: this.$t(resJson.code)})
              }
            }
            reader.readAsText(res)
          } else if (/application\/octet-stream/.test(res.type)) {

            let blob = new Blob([res])
            if (isIE()) {
              navigator.msSaveBlob(blob, 'Client Users List.xlsx')
            } else {
              let url = window.URL.createObjectURL(blob)
              let link = document.createElement('a')
              link.style.display = 'none'
              link.href = url
              link.setAttribute('download', 'Client Users List.xlsx')
              document.body.appendChild(link)
              link.click()
            }
          }
        } catch (e) {
        } finally {
          service.close()
        }
      },
      async addClientUser() {
        // 先判断有没有添加白名单
        const res = await API.clientUser.getSiteConfig({param: this.getSite.siteId})
        if (res.code == '1') {
          if (res.data.downloadWhiteList == '' || res.data.downloadWhiteList == null) {
            this.emailList = []
            this.$message.error(this.$t('SET_WHITE_LIST_FIRST'))
          } else {
            this.emailList = res.data.downloadWhiteList.split(',').map(item => {
              return {value: item}
            })
            this.initData = {}
            this.addVisible = !this.addVisible
          }
        } else {
          this.$message.error(this.$t(res.code));
        }
      },
      changeIdentityType(data) {
        const params = {
          siteId: this.siteId,
          userId: data.id,
          userName: data.userName,
          userAccount: data.userAccount,
          title: data.title,
          isContact: data.ifContact,
          roleIds: data.roleList,
          backMail: data.backMail,
          identityType: data.identityType,
          deactivateSetting: data.deactivateSetting,
        }
        API.clientUser
          .updateClientUser(params)
          .then(res => {
            if (res.code == '1') {
              this.$message.success(this.$t('msg_success'))
              this.getClientUserList()
            } else {
              this.$message.error(this.$t(res.code))
            }
          })
          .catch(e => {
            console.error(e);
            this.$message.error(this.$t('SYS_USER_003'))
          })
          .finally(() => {
            this.btnLoading = false
          })
      },
      saveClientUser(data) {
        this.btnLoading = true
        if (this.initData.id) {
          const params = {
            siteId: this.siteId,
            userId: this.initData.id,
            userName: data.userName,
            userAccount: data.userAccount,
            title: data.title,
            isContact: data.ifContact,
            roleIds: this.initData.roleList,
            backMail: data.backMail,
            identityType: data.identityType
          }
          API.clientUser
            .updateClientUser(params)
            .then(res => {
              if (res.code == '1') {
                this.$message.success(this.$t('msg_success'))
                this.addVisible = !this.addVisible
                this.getClientUserList()
              } else {
                this.$message.error(this.$t(res.code))
              }
            })
            .catch(e => {
              console.error(e);
              this.$message.error(this.$t('SYS_USER_003'))
            })
            .finally(() => {
              this.btnLoading = false
            })
        } else {
          const params = {
            siteId: this.siteId,
            userName: data.userName,
            userAccount: data.userAccount,
            title: data.title,
            isContact: data.ifContact,
            roleIds: data.role,
            identityType: data.identityType
          }
          API.clientUser
            .addClientUser(params)
            .then(res => {
              if (res.code == '1') {
                this.$message.success(this.$t('msg_success'))
                this.addVisible = !this.addVisible
                this.getClientUserList()
              } else {
                if (res.code == 'CLIENT_USER_003') {
                  this.$message.error(this.$t(res.code) + res.errDetails.msg);
                } else {
                  this.$message.error(this.$t(res.code));
                }
              }
            })
            .catch(e => {
              console.error(e);
              this.$message.error(this.$t('SYS_USER_003'))
            })
            .finally(() => {
              this.btnLoading = false
            })
        }
      },
      sendEmailOpen() {
        this.addVisibleEmail = !this.addVisibleEmail
      },
      sendEmail(data) {
        this.emailBtnLoading = true
        const accountList = []
        data.forEach(i => {
          accountList.push(i.userAccount)
        })
        const params = {
          userAccounts: accountList,
          siteId: this.siteId
        }
        API.clientUser
          .sendNotificationEmail(params)
          .then(res => {
            if (res.code == '1') {
              this.$message.success(this.$t('msg_success'))
              this.addVisibleEmail = !this.addVisibleEmail
              // 发送成功后重置一下提示气泡的状态
              this.checkIfUnsendPwdUserExist()
            } else {
              this.$message.error(this.$t(res.code))
            }
          })
          .catch(e => {
            console.error(e);
            this.$message.error(this.$t('SYS_USER_003'))
          })
          .finally(() => {
            this.emailBtnLoading = false
          })
      },
      toggleAddVisible() {
        this.addVisible = !this.addVisible
        this.initData = ''
      },
      toogleEmailVisible() {
        this.addVisibleEmail = !this.addVisibleEmail
      },
      roleListName(roles) {
        return _.map(roles, v => v.roleName).join('; ')
      },
      onDeactivateEdit(e) {
        let param = {
          clientId: [e.id],
          deactivateSetting: e.deactivateSetting,
          siteId: this.siteId,
        }
        API.clientUser.updateDeactivate(param).then(res => {
          if (res.code === '1') {
            this.$message.success(this.$t('msg_success'))
          } else {
            this.$message.error(this.$t(res.code))
          }
        })
      },
      onDeactivateBatchEdit(e) {
        let confirmationIdList = this.data.filter(item => item.deactivateSetting !== e && item.status === '1').map(v => v.id)
        let param = {
          clientId: confirmationIdList,
          deactivateSetting: e,
          siteId: this.siteId,
        }
        API.clientUser.updateDeactivate(param).then(res => {
          if (res.code === '1') {
            this.$message.success(this.$t('msg_success'))
            // 直接更新数据里的状态，不重新加载列表
            this.data = this.data.map(v => {
              if (v.deactivateSetting !== e && v.status === '1') {
                v.deactivateSetting = e
              }
              return v
            })
          } else {
            this.$message.error(this.$t(res.code))
          }
        })
      },
      getDeactivateSettingOptions() {
        API.common.getDict({dictName: 'deactivate_setting'}).then(res => {
          if (res.code === '1') {
            this.deactivateSettingOptions = res.data
          }
        })
      },
       updateGuideClass({ row, column, rowIndex, columnIndex }) {
            if (
                this.updateGuide && columnIndex == 14
            ) {
                return 'updateGuideFixedHeaderTitle'
            }
            return ''
        },
      changeGuideTitleHeight() {
            setTimeout(() => {
                this.updateGuideTitleHeight = document.getElementsByClassName('el-table__header-wrapper')[0].clientHeight
            }, 500)
        },
    },
   
  }
</script>
<style scoped>
.updateGuide {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0.5;
    background: #000;
    z-index: 100;
}
  .wl-container {
    height: 100%;
    background: #eff1f5;
    padding: 22px;
  }

  .wl-content-container {
    background: #fff;
    height: 100%;
    padding: 22px 22px 16px 22px;
    border-radius: 8px;
  }

  .wl-search-bar {
    height: 90PX;
  }

  .wl-left,
  .wl-right {
    height: 45PX;
    display: flex;
    align-items: flex-start;
  }

  .wl-left {
    justify-content: flex-start;
  }

  .wl-right {
    justify-content: flex-end;
  }

  .input-with-select {
    width: 260px;
    margin-right: 12px;
  }

  .wl-overflow-tooltip {
    overflow: hidden;
    display: inline-block;
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .template-uploader {
    margin-left: 10px;
  }

  .warning-cls {
    color:#fd349c;
    margin-left: 5px;
    cursor: pointer;
  }

  ::v-deep .el-table .el-table__body tr td.el-table__cell.red {
    background-color: rgba(255, 227, 230, 1);
  }

  ::v-deep .el-table .el-table__body tr.el-table__row.confirmation-user-row > td.el-table__cell {
    background-color: #F2FAF5;
  }

  ::v-deep .el-table .el-table__body tr.el-table__row.confirmation-user-row.hover-row > td.el-table__cell {
    background-color: #E5F5EC;
  }

  .table-container-wrapper {
    height: calc(100% - 48px - 98PX);
    position: relative;
  }

  .table-container-wrapper .show-table-bottom-operate {
    height: calc(100% - 98px - 80PX);
  }

  .wl-btn-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 50px;
  }

  .clientUser-popver-content {
    margin-left: -268px;
    margin-top: -104px;
    background: #303133;
    color: #FFF;
  }

  .popver-arrow {
    position: absolute;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 20px solid #303133;
    width: 0;
    height: 0;
    right: 100px;
  }

  .th {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .th-label {
    float: left;
  }

  .th-edit {
    font-size: 16px;
    color: #3879eb;
    margin-left: 5px;
  }

  .updateGuideTitle {
    position: absolute;
    background-color: white;
    height: 45px;
    z-index: 2003;
    border: 2px solid #3879eb !important;
    border-radius: 10px;
    width: 370px;
}

.margin-bottom-10 {
    margin-bottom: 10px;
}
.guide-btn {
    float: right;
    color: #3879eb;
}

.updateGuideTitle .updateGuideTip {
    z-index: 2003;
    background-color: #3879eb;
    padding: 20px;
    color: white;
    position: absolute;
    left: 0;
    top: 42px;
    width: 360px;
    border-radius: 10px;
    text-align: left;
    font-size: 14px;
    line-height: normal;
}
::v-deep .guide-table  .el-table__fixed-header-wrapper{
    z-index: 2003;
}
.updateGuide {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0.5;
    background: #000;
    z-index: 100;
}
::v-deep .guide-table .el-table .el-table__header tr:nth-child(1) th {
   border: none;
}
</style>

